import { useEffect, useRef } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import EmptyState from "../common/EmptyState";

export default function AppointmentCalendar({
  events,
  onDatesChange,
  onSelectAppointment,
  refreshSignal,
  emptyTitle = "No appointments available",
  emptySubtitle = "Appointments for the selected range will appear here.",
}) {
  const calendarRef = useRef(null);

  useEffect(() => {
    if (refreshSignal != null) {
      calendarRef.current?.getApi().updateSize();
    }
  }, [refreshSignal]);

  return (
    <div id="calendarRoot">
      <FullCalendar
        ref={calendarRef}
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
        initialView="dayGridMonth"
        timeZone="Asia/Dubai"
        headerToolbar={{
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay",
        }}
        slotMinTime="10:00:00"
        slotMaxTime="21:00:00"
        allDaySlot={false}
        height="auto"
        nowIndicator
        events={events}
        datesSet={onDatesChange}
        eventClick={(info) =>
          onSelectAppointment({ id: info.event.id, ...info.event.extendedProps })
        }
      />
      {!events.length ? (
        <div className="calendar-empty-state">
          <EmptyState title={emptyTitle} subtitle={emptySubtitle} />
        </div>
      ) : null}
    </div>
  );
}
